<template>
  <div class="pd-t-60">
    <div class="">
      <div class="row no-gutters">
        <div class="col-lg-2 col-md-3 bg-light bd-r">
          <vue-custom-scrollbar
            :settings="{ maxScrollbarLength: 60 }"
            :style="`height:calc(100vh - 250px)`"
            class="pd-20"
          >
            <b-row>
              <b-col class="text-center">
                <img
                  src="https://res.gosmart.mn/media/logo/vet.png"
                  style="width: 50%"
                />
              </b-col>
              <!-- <b-col lg="12">
                        <b-form-group
                        label="Эрэмбэ"
                        label-cols-sm="12"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="sortBySelect"
                        class="mb-0"
                        >
                        <b-input-group size="sm">
                            <b-form-select v-model="sortBy" id="sortBySelect" :options="sortOptions" class="w-75">
                            <template #first>
                                <option value="">-- сонгоогүй --</option>
                            </template>
                            </b-form-select>
                            <b-form-select v-model="sortDesc" size="sm" :disabled="!sortBy" class="w-25">
                            <option :value="false">Өсөх</option>
                            <option :value="true">Буурах</option>
                            </b-form-select>
                        </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col lg="12">
                        <b-form-group
                        label="Анхны эрэмбэ"
                        label-cols-sm="12"
                        label-align-sm="right"
                        label-size="sm"
                        label-for="initialSortSelect"
                        class="mb-0"
                        >
                        <b-form-select
                            v-model="sortDirection"
                            id="initialSortSelect"
                            size="sm"
                            :options="['asc', 'desc', 'last']"
                        ></b-form-select>
                        </b-form-group>
                    </b-col> -->

              <b-col lg="12">
                <b-form-group
                  label="Хайх"
                  label-cols-sm="12"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
                >
                  <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Хайх утгаа бичнэ үү"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''"
                        >Бүгд</b-button
                      >
                    </b-input-group-append>
                  </b-input-group>
                </b-form-group>
              </b-col>

              <!-- <b-col lg="12">
                        <b-form-group
                        label="Талбараар хайх"
                        label-cols-sm="12"
                        label-align-sm="right"
                        label-size="sm"
                        description="Утга сонгоогүй тохиолдолд бүх баганаас хайна"
                        class="mb-0">
                        <b-form-checkbox-group v-model="filterOn" class="mt-1">
                            <b-form-checkbox v-for="(f,i) in sortOptions" :key="i" :value="f.value">{{f.text}}</b-form-checkbox>
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col> -->

              <b-col md="12">
                <b-form-group
                  label="Харуулах мөрийн тоо"
                  label-cols-sm="12"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="perPageSelect"
                  class="mb-0"
                >
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  hide-goto-end-buttons
                  :limit="5"
                ></b-pagination>
              </b-col>
            </b-row>
          </vue-custom-scrollbar>
        </div>
        <div class="col">
          <div class="pd-20">
            <div class="d-flex mg-b-10">
              <div>
                <h4 class="mg-b-0">Тусгай зөвшөөрөл</h4>
                <div class="btn-group">
                  <a
                    href="http://help.vetdrug.mn/#/vet-landing-help/45067/1380132"
                    target="_blank"
                    class="btn btn-outline-success btn-xs"
                  >
                    <feather type="help-circle"></feather>
                    Бүрдүүлэх материал
                  </a>
                  <a
                    href="http://help.vetdrug.mn/#/vet-landing-help/45048/1378865"
                    target="_blank"
                    class="btn btn-outline-primary btn-xs"
                  >
                    <feather type="award"></feather>
                    Шинээр тусгай зөвшөөрөл авах
                  </a>
                </div>
              </div>
              <div class="mg-l-auto d-flex">
                <div class="media">
                  <div
                    class="wd-40 wd-md-50 ht-40 ht-md-50 bg-primary tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6"
                  >
                    <feather type="bar-chart-2"></feather>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                    >
                      Нийт
                    </h6>
                    <h4
                      class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                    >
                      {{ totalRows }}
                    </h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-20">
                  <div
                    class="wd-40 wd-md-50 ht-40 ht-md-50 bg-teal tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-6"
                  >
                    <feather type="bar-chart-2"></feather>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold tx-nowrap mg-b-5 mg-md-b-8"
                    >
                      Хүчинтэй
                    </h6>
                    <h4
                      class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                    >
                      {{
                        items.filter(
                          x => x._cellVariants.expireDate == "success"
                        ).length
                      }}
                    </h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-20">
                  <div
                    class="wd-40 wd-md-50 ht-40 ht-md-50 bg-pink tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-5"
                  >
                    <feather type="bar-chart-2"></feather>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                    >
                      Хүчингүй
                    </h6>
                    <h4
                      class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                    >
                      {{
                        items.filter(
                          x => x._cellVariants.expireDate == "danger"
                        ).length
                      }}
                    </h4>
                  </div>
                </div>
                <div class="media mg-t-20 mg-sm-t-0 mg-sm-l-15 mg-md-l-20">
                  <div
                    class="wd-40 wd-md-50 ht-40 ht-md-50 bg-warning tx-white mg-r-10 mg-md-r-10 d-flex align-items-center justify-content-center rounded op-4"
                  >
                    <feather type="bar-chart-2"></feather>
                  </div>
                  <div class="media-body">
                    <h6
                      class="tx-sans tx-uppercase tx-10 tx-spacing-1 tx-color-03 tx-semibold mg-b-5 mg-md-b-8"
                    >
                      Хугацаа дөхсөн
                    </h6>
                    <h4
                      class="tx-20 tx-sm-18 tx-md-24 tx-normal tx-rubik mg-b-0"
                    >
                      {{
                        items.filter(
                          x => x._cellVariants.expireDate == "warning"
                        ).length
                      }}
                    </h4>
                  </div>
                </div>
              </div>
            </div>
            <vue-custom-scrollbar
              :settings="{ maxScrollbarLength: 60 }"
              :style="`height:calc(100vh - 250px)`"
            >
              <b-table
                class="table table-striped dataTable no-footer"
                :busy="isBusy"
                show-empty
                small
                empty-text="Тохирох мэдээлэл олдсонгүй"
                stacked="md"
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
                @filtered="onFiltered"
                @row-clicked="info"
              >
                <template #cell(actions)="row">
                  <a
                    class="btn btn-xs pd-x-15 btn-primary btn-uppercase tx-13 text-white"
                    role="button"
                    @click="info(row.item)"
                  >
                    Дэлгэрэнгүй
                  </a>
                </template>

                <template #row-details="row">
                  <b-card>
                    <ul>
                      <li v-for="(value, key) in row.item" :key="key">
                        {{ key }}: {{ value }}
                      </li>
                    </ul>
                  </b-card>
                </template>
                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Түр хүлээнэ үү...</strong>
                  </div>
                </template>
              </b-table>
            </vue-custom-scrollbar>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-1"
      v-model="showModal"
      title="Дэлгэрэнгүй"
      hide-footer
      size="lg"
      no-fade
      centered
    >
      <div
        v-for="f in fields.filter(x => x.key != 'actions')"
        :key="f.key"
        class="bd-b row no-gutters pd-10"
      >
        <div class="col-5 text-right font-weight-bolder">{{ f.label }}:</div>
        <div class="col-7">
          <div class="pd-l-10">{{ detail[f.key] }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";
const moment = require("moment");
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
  components: {
    vueCustomScrollbar
  },
  data() {
    return {
      items: [],
      fields: [
        {
          key: "name",
          label: "Байгууллагын нэр",
          sortable: true,
          sortDirection: "desc"
        },
        { key: "city", label: "Байршил", sortable: true },
        { key: "phone", label: "Утас", sortable: true },
        { key: "email", label: "Цахим шуудан", sortable: true },
        { key: "type", label: "Тусгай зөвшөөрлийн төрөл", sortable: true },
        { key: "expireDate", label: "Хүчинтэй огноо", sortable: true },
        { key: "actions", label: "-" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [10, 20, 50, { value: 100, text: "Илүү их" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      },
      showModal: false,
      isBusy: false,
      detail: {}
    };
  },
  mounted() {
    require("@/assets/scss/pages/landing.scss");
    this.init();
  },
  methods: {
    init() {
      this.isBusy = true;
      request({
        api: { method: "POST", url: "Vetmed/CompanyList" },
        data: { page: 0, size: 200 },
        store: this.$store
      }).then(res => {
        this.isBusy = false;
        if (res != false) {
          this.items = res.data.list.map(e => {
            let vrnt = "";
            if (moment(e.expireDate).isBefore(moment(res.data.now))) {
              vrnt = "danger";
            } else if (
              moment(e.expireDate)
                .add(-3, "months")
                .isBefore(moment(res.data.now))
            ) {
              vrnt = "warning";
            } else vrnt = "success";

            e._cellVariants = {
              expireDate: vrnt
            };
            e.expireDate = moment(e.expireDate).format("YYYY.MM.DD");
            return e;
          });
          this.totalRows = this.items.length;
        }
      });
    },
    info(id) {
      this.detail = id;
      this.showModal = true;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  }
};
</script>
